import { yupResolver } from "@hookform/resolvers/yup"
import { Button, Stack } from "@mui/material"
import React from 'react'
import { FormProvider, useForm } from "react-hook-form"
import * as yup from "yup"
import { CngField } from "./CngField"
import { useHelper } from "../HelperContext"
import { FormActions } from "../components"
import { useTranslations } from "./useTranslations"

const schema = yup.object({
  username: yup.string().required("Username is required"),
  password: yup.string().required("Password is required"),
})

export const Form = () => {
  const { cngRef, setLoginError } = useHelper()
  const translatedTextsObject = useTranslations()

  const form = useForm({
    defaultValues: {
      username: '',
      password: ''
    },
    resolver: yupResolver(schema),
    mode: 'onChange'
  })

  const handleLogin = (e) => {
    setLoginError(null)
    e.preventDefault(); e.stopPropagation()
    const cngSubmit = cngRef.current.querySelector('button[type="submit"]')

    if (cngSubmit)
      cngSubmit.click()

  }

  return <>
    <FormProvider {...form}>
      <Stack component='form' gap='1.5rem'>
        <CngField name='username' type="text"
          label={translatedTextsObject.userId}
          autoFocus autoComplete="off" required
        />
        <CngField name='password' label='Password'
          type='password' autoComplete="off" required
        />
      </Stack>

      <FormActions>
        <Button variant='contained' type="submit"
          id="loginSubmit" name="loginSubmit"
          onClick={handleLogin} fullWidth
        >
          Sign In
        </Button>
      </FormActions>
    </FormProvider>
  </>
}